interface DateHeaderProps {
  date: Date;
}

function getOrdinalSuffix(day: number): string {
  if (day > 3 && day < 21) return "th";
  switch (day % 10) {
    case 1: return "st";
    case 2: return "nd";
    case 3: return "rd";
    default: return "th";
  }
}

const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

const DAYS = [
  "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday",
];

export function DateHeader({ date }: DateHeaderProps) {
  const dayName = DAYS[date.getDay()];
  const month = MONTHS[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();
  const ordinal = getOrdinalSuffix(day);

  return (
    <div className="flex items-baseline gap-3 pl-1.5 mt-2 pr-2">
      <span className="text-[32px] leading-10 text-on-surface font-stretch-120% font-semibold">
        {dayName}
      </span>
      <span className="text-base leading-6 text-outline">
        {month} {day}{ordinal}, {year}
      </span>
    </div>
  );
}
